var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-order-detail"},[_c('div',{staticClass:"tt-order-detail__label"},[_vm._v(" "+_vm._s(_vm.$t(_vm.i18nKey))+" ")]),_c('div',{staticClass:"tt-order-detail__value"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }